export default "<footer>\n    \n</footer>\n\n"